export enum ResourceType {
    ENTRY = 'ENTRY',
    CALCULATION = 'CALCULATION',
}

export enum CarryForwardLinkedResourceType {
    ENTRY = 'ENTRY',
}

export type MappedWorksheetMetadata = {
    priorWorksheetId: string;
    priorWorksheetName: string;
    outcome: 'error' | 'success' | 'not attempted';
    errorMessage?: string;
    lastAttempted?: Date;
};

export type LinkedResourceMetadata = {
    priorResourceId: string;
    priorResourceName?: string;
    outcome: 'error' | 'success' | 'not attempted';
    resourceType: CarryForwardLinkedResourceType;
    currentResourceId?: string;
    errorMessage?: string;
    lastAttempted?: Date;
};

export type CarryForwardCalculationResultMetadata = {
    resourceName?: string;
    outcomeMessage?: string;
    mappedWorksheets: MappedWorksheetMetadata[];
    linkedResources: LinkedResourceMetadata[];
};

export type CarryForwardManualEntryResultMetadata = {
    resourceName?: string;
    outcomeMessage?: string;
};

export type CarryForwardResultDB = {
    id: string;
    workpaperId: string;
    firmId: string;
    resourceType: ResourceType;
    priorResourceId: string;
    currentResourceId?: string;
    outcome: string;
    carryForwardDate?: Date;
    carryForwardBy?: string;
    lastAttemptedAt: Date;
    lastAttemptedBy?: string;
    metadata: CarryForwardCalculationResultMetadata | CarryForwardManualEntryResultMetadata;
    createdAt: Date;
    updatedAt: Date;
}[];

export type CarryForwardResourcePayload = {
    type: ResourceType;
    priorResourceId: string;
};

export type CarryForwardResourcesPayload = {
    priorWorkpaperId: string;
    currentWorkpaperId: string;
    payloads: CarryForwardResourcePayload[];
};
